/* eslint-disable react/display-name */
import PortableText from '@sanity/block-content-to-react';
import { Text, View } from '@react-pdf/renderer';
import { FC, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  node: {
    style: string;
  };
}

const serializers = {
  list: (props: Props) => <View>{props.children}</View>,
  listItem: (props: Props) => (
    <View style={{ width: '100%', marginTop: 7, flexDirection: 'row' }}>
      <Text>*</Text>
      <Text style={{ paddingLeft: 5 }}>{props.children}</Text>
    </View>
  ),
  types: {
    block(props: Props) {
      switch (props.node.style) {
        case 'div':
          return <View>{props.children}</View>;
        case 'li':
          return (
            <View style={{ width: '100%', marginTop: 7, flexDirection: 'row' }}>
              <Text>*</Text>
              <Text style={{ paddingLeft: 5 }}>{props.children}</Text>
            </View>
          );
        case 'p':
          return <Text style={{ width: '100%', marginBottom: 10 }}>{props.children}</Text>;
        default:
          return <Text>{props.children}</Text>;
      }
    },
  },
};

const PDFPortableText: FC<{ blocks: SanityRichText[] }> = ({ blocks }) => {
  return <PortableText blocks={blocks} serializers={serializers} />;
};

export default PDFPortableText;
